import styled, { css } from 'styled-components';

import product from '../../services/product';

const queryBreak = '1100px';

interface LoadingParam {
  hasLoading: boolean;
}

export const Container = styled.div`
  display: flex;
  max-width: 1240px;
  margin: 0 auto;
  padding: 40px 20px;

  @media (max-width: ${queryBreak}) {
    flex-direction: column;
  }
`;

export const Sidebar = styled.aside`
  max-width: 420px;
  min-width: 420px;

  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #f7f7f7;
  margin-left: auto;

  @media (max-width: ${queryBreak}) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    margin-left: 0;
    order: 1;
  }

  header {
    background-color: ${product.background};
    color: #4d4d4d;
    padding: 30px;
    font-weight: 300;
    line-height: 1.4;
    display: flex;
    justify-content: flex-end;
  }

  section {
    margin: 0 30px;
    padding: 20px 0;

    border-bottom: 1px solid #dcdcdc;

    span {
      font-family: 'Quicksand', sans-serif;
      color: #717171;
      font-weight: 300;
      font-size: 0.875rem;
    }

    h3 {
      font-family: 'Barlow', sans-serif;
      margin: 8px 0 0 0;
      font-size: 21px;
      font-weight: 400;
      line-height: 28px;
    }

    h4 {
      font-family: 'Barlow', sans-serif;
      font-size: 15px;
      color: #3e3e3e;
      align-items: center;
      padding-bottom: 5px;
      margin: 8px 0 0 0;
    }
  }

  footer {
    margin: 0 30px;
    padding: 20px 0;
    display: flex;
    align-items: center;

    justify-content: space-between;
    span {
      font-family: 'Quicksand', sans-serif;
      color: #717171;
      font-weight: 300;
      font-size: 0.875rem;
    }

    div {
      font-family: 'Quicksand', sans-serif;
      font-size: 18px;
      color: #3f3e3e;
      font-weight: bold;
    }
  }
`;

export const ContainerForm = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;

  @media (max-width: ${queryBreak}) {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    order: 2;

    flex-direction: column;
  }
`;

export const Form = styled.form`
  flex: 1;
  margin-right: 30px;
  padding: 15px;

  div {
    width: 100%;
    margin-bottom: 20px;

    input {
      width: 100%;
      flex: 1;
      height: 45px;
      padding: 0 16px;
      border: 0;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  }

  section {
    display: flex;
    margin-bottom: 20px;
    input {
      width: 100%;
      flex: 1;
      height: 45px;
      padding: 0 16px;
      border: 0;
      border-radius: 5px;
      border: 1px solid #ccc;

      & + input {
        margin-left: 20px;
      }
    }
  }

  button {
    display: block;
    margin-left: auto;
    width: 230px;
    height: 60px;
    background: #7cd063;
    border-radius: 5px;
    border: 0;
    color: #ffffff;
    font-weight: bold;
    transition: background-color 1s;
    font-size: 18px;

    &:hover {
      background: #04d361;
    }
  }
`;

export const Card = styled.div`
  margin-right: 30px;
  min-width: 300px;

  @media (max-width: ${queryBreak}) {
    min-width: 100%;
    width: 100%;
  }
`;

export const Loading = styled.div<LoadingParam>`
  display: none;

  ${(props) =>
    props.hasLoading &&
    css`
      display: block;
      width: 240px;
      height: 240px;
      position: absolute;
      top: calc(50% - 140px);
      left: calc(50% - 140px);
      z-index: 99999;

      span,
      img {
        background: url(https://app.qesh.ai/static/media/qesh-logo-color-vtc-neg.26a95d78.svg);
        width: 120px;

        position: absolute;
        top: calc(50% - 60px);
        left: calc(50% - 30px);
        left: 100px;
      }

      div {
        width: 280px;
        height: 280px;
        animation: spinloading 2s infinite linear;
        display: block;
        margin: 0 auto;
        transform-origin: 55% 50%;

        position: fixed;
        background-color: rgba(0, 0, 0, 0.7);
        background: url(https://app.qesh.ai/static/media/circular-arrow-with-dots.e69b33e5.svg);
        background-size: cover;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;

        @keyframes spinloading {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }
    `}
`;
